//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import { AccountingNotes } from '@/views/accountingRecords'
import GenerateConciliation from '@/views/accountingRecords/accountConciliation/GenerateConciliation'

//
export default {
    path: 'accounting_notes',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'accounting-notes-list',
            component: AccountingNotes,
        },
        {
            path: 'conciliation',
            name: 'accounting-notes-conciliation',
            component: GenerateConciliation,
        },
    ],
    meta: {
        group: 'Contabilidad',
        title: 'Apuntes contables',
    },
}
